import { DocProperty, InheritedDoc } from 'typescript-openapi-router';
import { ActiveAlertModel } from '../model';
import { ResponseEnvelope } from './response-envelope';

@InheritedDoc()
export class AlertListResponse extends ResponseEnvelope {

  @DocProperty({
    type: 'object',
    objectType: ActiveAlertModel.name,
    isRequired: false
  })
  data?: ActiveAlertModel[];
}
